import styled from 'styled-components';
import { styledHeader, Typography } from './BaseTypes';
import { styledMargin } from '../layout/Margin';

export const H4 = styled.h4<Typography>`
  ${styledHeader}
  ${styledMargin}
  font-size: 24px;
`;
